/**
 * @fileoverview Registration contact information section.
 * @module components/AppointmentRegistrationSections/ContactInformation/index
 */
import styles from "./ContactInformation.module.css";
import { useContactInformationForm } from "./useContactInformationForm.js";
import {
  RegistrationEmailField,
  RegistrationOfficePhoneField,
  RegistrationWebsiteField,
} from "./RegistrationContactFields.jsx";

const ContactInformation = ({
  company,
  onFieldChange,
  onValidationChange,
  missingRequiredFields,
  getFieldValidation,
}) => {
  const form = useContactInformationForm({
    company,
    onFieldChange,
    onValidationChange,
  });
  const fieldProps = {
    company,
    styles,
    form,
    missingRequiredFields,
    getFieldValidation,
  };

  return (
    <div className={styles.sectionContent}>
      <div className={styles.sectionHeader}>
        <span className={styles.sectionTitle}>
          {form.t("components.contactInformation.title")}
        </span>
        <div className={styles.sectionDivider}></div>
      </div>
      <div className={styles.inputRow}>
        <RegistrationOfficePhoneField {...fieldProps} />
        <RegistrationEmailField {...fieldProps} />
      </div>
      <RegistrationWebsiteField {...fieldProps} />
    </div>
  );
};

export default ContactInformation;
